import { Breadcrumb, Container } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';

const ChatbotLayout = () => {
  return (
    <Container>
      <Breadcrumb>
        <Breadcrumb.Item active>Chatbot</Breadcrumb.Item>
      </Breadcrumb>
      <Outlet />
    </Container>
  );
};

export default ChatbotLayout;
